module.exports = __webpack_public_path__ + "media/images/flags/pf-79ba6e3c2d14b2c57c926bae8fddfe72.svg";